"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useFoodItemSelectorStyle = () => {
    const theme = (0, material_1.useTheme)();
    const container = Object.assign(Object.assign({ width: '%100', minHeight: '1.5rem', boxShadow: 'none' }, theme.qlub.typography.body_sm), { display: 'flex', flexDirection: 'column', gap: '0.5rem' });
    const foodItemCard = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: 'none',
    };
    const foodCard = {
        display: 'flex',
        alignItems: 'center',
        padding: '0',
        gap: '0.5 rem',
        position: 'relative',
        '& .foodName': {
            color: theme.qlub.palette.onSurfaceColors.highEmphasis,
        },
        '& .quantity': {
            color: theme.qlub.palette.iris_light.hover,
        },
        '& .number': Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.highEmphasis, position: 'absolute', display: 'flex', justifyContent: 'center', alighItems: 'center', width: '1rem', height: '1.0625rem', insetInlineStart: '0.25rem', insetBlockStart: '0.25rem' }),
    };
    const selectorStyle = Object.assign({ display: 'flex', padding: 0, alignItems: 'center', gap: '0.5rem' }, theme.qlub.typography.body_sm);
    const priceStyle = {
        color: theme.qlub.palette.onSurfaceColors.highEmphasis,
    };
    const discountStyle = {
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        textDecorationLine: 'line-through',
    };
    const countStyle = {
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        width: '1.25rem',
        display: 'flex',
        justifyContent: 'center',
    };
    const attributeStyle = {
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'center',
    };
    return {
        container,
        foodItemCard,
        foodCard,
        selectorStyle,
        priceStyle,
        discountStyle,
        attributeStyle,
        countStyle,
    };
};
exports.default = useFoodItemSelectorStyle;
